import React from 'react'
import PropTypes from 'prop-types'

import Styles from './index.scss'

const tabMenu = [
  {
    id: 0,
    name: 'Project Details',
  },
  {
    id: 1,
    name: 'Pitch Summary',
  },
  {
    id: 2,
    name: 'Quotation & Po',
  },
  {
    id: 3,
    name: 'Invoices',
  },
  {
    id: 4,
    name: 'Task List',
  },
  {
    id: 5,
    name: 'Rating & Review',
  },
]

const TabMenu = props => (
  <div className={Styles['menu-container']}>
    <ul className={Styles.list}>
      {tabMenu.map(tab => (
        <li key={tab.id}>
          <button
            className={`${Styles['list-item']} ${props.tabActive === tab.id ? Styles.active : ''}`}
            onClick={props.setTabActive(tab.id)}
          >
            {tab.name.toUpperCase()}
          </button>
        </li>
      ))}
    </ul>
  </div>
)

TabMenu.propTypes = {
  setTabActive: PropTypes.func.isRequired,
}

export default TabMenu
